"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appHTMLElementsKey = exports.appModules = void 0;
/**
 * Mapping of application module names to their IDs.
 */
exports.appModules = {
    "OPERACIONES": 1,
    "INGRESO_MEDICOS": 2,
    "USUARIOS": 3,
};
/**
 * Mapping of application HTML elements keys.
 */
exports.appHTMLElementsKey = {};
